import { useApiContext } from "@/setup/flexbiz-api-provider";
import sanitizeDOMData from "@/utils/sanitizeDOMData";
import styled from "@emotion/styled";
import { Button, Grid } from "@mantine/core";
import React from "react";
const Wrapper = styled.div`
  border-bottom: 0.3px solid rgba(0, 0, 0, 0.1);
  border-top: 0.3px solid rgba(0, 0, 0, 0.1);
  background-color: ${(props) => (props.bgColor ? props.bgColor : "inherit")};
`;
const Hover = styled.div`
  padding: 10px 5px;
  width: 100%;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: 2px 1px 6px rgba(0, 0, 0, 0.19);
    div {
      div {
        -webkit-line-clamp: 2;
        /* height: 80px;
        transition: height 2s; */
      }
    }
  }
`;
const Datep = styled.p`
  font-size: 12px;
  padding-top: 5px;
  color: #7c8182;
`;
const TitleNoti = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  -webkit-line-clamp: 1;
  height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;
const Noti = styled.div`
  width: 100%;
  opacity: ${(props) => {
    props.active ? 1 : 0.5;
  }};
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  -webkit-line-clamp: 2;
  height: 40px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  padding-left: 10px;
`;
export default function NotificationItem({ data, setReFetch }) {
  //   console.log(data);
  const context = useApiContext();
  const handleDelete = async (id) => {
    try {
      await context.apis.asyncDeleteList(
        context?.userInfo?.token,
        "notification",
        id
      );
      //   console.log(a);
      setReFetch((prev) => prev + 1);
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Wrapper>
      <Grid>
        <Grid.Col span={10}>
          <Hover>
            <TitleNoti>{sanitizeDOMData(data?.title)}</TitleNoti>
            <Noti>{sanitizeDOMData(data?.content)}</Noti>
            <Datep>
              {new Date(data?.date_updated).toLocaleDateString("vi", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              })}
            </Datep>
          </Hover>
        </Grid.Col>
        <Grid.Col
          span={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            sx={{
              color: "red",
              background: "white",
              height: "100%",
              width: "100%",
              padding: 0,
            }}
            onClick={() => handleDelete(data?._id)}
          >
            Xoá
          </Button>
        </Grid.Col>
      </Grid>
    </Wrapper>
  );
}
